module.exports = __webpack_public_path__ + "static/media/novair_white.91534773.svg";